/**
 * Reassurance Bar — Mobile Ticker
 * assets/reassurance-bar-ticker.js
 *
 * Only handles the mobile carousel (auto-rotate + arrows).
 * The HTML is rendered natively in Liquid — no DOM injection.
 */
(function () {
  var bar = document.querySelector('.ig-reassurance-bar');
  if (!bar) return;

  var track = bar.querySelector('.ig-reassurance-track');
  if (!track) return;

  var slides = track.querySelectorAll('.ig-reassurance-slide');
  if (slides.length <= 1) return;

  var index = 0;
  var DELAY = 3000;
  var timer = null;

  function isMobile() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  function go(i) {
    index = ((i % slides.length) + slides.length) % slides.length;
    track.style.transform = 'translateX(' + (-index * 100) + '%)';
  }

  function stop() {
    if (timer) { clearTimeout(timer); timer = null; }
  }

  function loop() {
    stop();
    if (!isMobile()) return;
    timer = setTimeout(function () {
      go(index + 1);
      loop();
    }, DELAY);
  }

  var prev = bar.querySelector('.ig-prev');
  var next = bar.querySelector('.ig-next');

  if (prev) prev.addEventListener('click', function () { go(index - 1); loop(); });
  if (next) next.addEventListener('click', function () { go(index + 1); loop(); });

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) loop();
  });

  go(0);
  loop();
})();